import styled from '@emotion/styled';
import { Tooltip } from 'antd';
import type { FC } from 'react';
import { HStack } from '../MetaComponent';

type Props = {
  children: React.ReactElement;
  object: Record<string, any>;
  tooltipPosition?: 'top' | 'right' | 'bottom' | 'left';
};

export const TooltipForAnObject: FC<Props> = ({ children, object, tooltipPosition = 'top' }) => {
  if (!object) return null;

  const tooltip = (
    <HStack>
      <table style={{ textAlign: 'right', lineHeight: '1.7' }}>
        <tbody>
          {Object.entries(object).map(
            ([key, value]) =>
              typeof value === 'string' && (
                <tr key={key}>
                  <td>
                    <strong>{key}:</strong>
                  </td>
                  <td style={{ paddingLeft: '10px' }}>{value}</td>
                </tr>
              ),
          )}
        </tbody>
      </table>
    </HStack>
  );

  if (children == null) return <></>;

  return (
    <Tooltip placement={tooltipPosition} title={tooltip} mouseEnterDelay={0.5}>
      {children}
    </Tooltip>
  );
};

export const HStackBaseline = styled(HStack)`
  align-items: baseline;
  max-width: 500px;
`;
